import CategoryTabs from './category-tabs';

export default CategoryTabs;
export { CategoryTabs };
